"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable complexity */
/* eslint-disable max-statements */
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const b_1 = __importDefault(require("b_"));
const pythia_libs_1 = require("@yandex-int/pythia-libs");
const youtube_player_1 = __importDefault(require("youtube-player"));
const button_1 = __importDefault(require("src/components/button"));
const vh_player_1 = __importDefault(require("../vh-player"));
const question_1 = __importDefault(require("../question"));
const video_status_bar_1 = __importDefault(require("./video-status-bar"));
const question_video_styles_1 = __importDefault(require("./question-video.styles"));
// import {QuestionProps} from '../question/question';
// import { VideoAttachment, VideoQuestionViewMode } from '../types';
const b = b_1.default.with('question-video');
const RECALC_TIMEOUT = 100;
/* export interface ClickData {
    timestamp: number;
    downTime: number;
    upTime: number;
}
export interface QuestionVideoProps extends QuestionProps {
    handleEnd: (clicks: {clicks: ClickData[]}) => void;
    after: {
        label: string;
    };
    attachment: VideoAttachment;
    mode?: VideoQuestionViewMode;
} */
function QuestionVideo(props) {
    const i18n = (0, pythia_libs_1.i18n)(['video']);
    const { id, children, after, mode = 'pointer-hold', handleEnd = () => { } } = props, rest = __rest(props, ["id", "children", "after", "mode", "handleEnd"]);
    const { service } = props.attachment;
    const attachmentRef = (0, react_2.useRef)();
    const clicksRef = (0, react_2.useRef)([]);
    const playerRef = (0, react_2.useRef)(null);
    const [duration, setDuration] = (0, react_2.useState)(0);
    const [currTime, setCurrTime] = (0, react_2.useState)(0);
    const [isHolding, setIsHolding] = (0, react_2.useState)(false);
    const [step, setStep] = (0, react_2.useState)('start');
    const handleClickToggle = (0, react_2.useCallback)(holding => {
        setIsHolding(holding);
        if (step !== 'playback') {
            return;
        }
        if (holding) {
            const clickData = {
                timestamp: Date.now(),
                downTime: currTime,
                upTime: currTime
            };
            clicksRef.current = [...clicksRef.current, clickData];
        }
        else if (clicksRef.current.length) {
            clicksRef.current[clicksRef.current.length - 1].upTime = currTime;
        }
    }, [currTime, step]);
    const onMouseDown = (0, react_2.useCallback)(() => {
        handleClickToggle(true);
    }, [handleClickToggle]);
    const onMouseUp = (0, react_2.useCallback)(() => {
        handleClickToggle(false);
    }, [handleClickToggle]);
    const onClickStartVideo = (0, react_2.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        yield playerRef.current.playVideo();
    }), []);
    (0, react_2.useEffect)(() => {
        let interval;
        if (step === 'playback' && !interval && !duration) {
            // TODO складывать таймер в ref
            interval = setInterval(() => {
                playerRef.current.getDuration().then(dur => {
                    if (dur) {
                        setDuration(dur);
                    }
                });
            }, RECALC_TIMEOUT);
        }
        else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [step, duration]);
    (0, react_2.useEffect)(() => {
        let interval;
        if (!interval && step === 'playback') {
            // TODO складывать таймер в ref
            interval = setInterval(() => {
                playerRef.current.getCurrentTime().then(currentTime => {
                    if (!currentTime) {
                        // в FF иногда получаем нули
                        return;
                    }
                    setCurrTime(currentTime);
                    if (isHolding && clicksRef.current.length) {
                        clicksRef.current[clicksRef.current.length - 1].upTime = currentTime;
                    }
                });
            }, RECALC_TIMEOUT);
        }
        else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [step, isHolding]);
    (0, react_2.useEffect)(() => {
        const playerContructor = service === 'youtube' ? youtube_player_1.default : vh_player_1.default;
        playerRef.current = playerContructor(attachmentRef.current);
    }, [service]);
    const onStateChange = (0, react_2.useCallback)(e => {
        if (e.data === 0) {
            setStep('end');
            playerRef.current.destroy();
            // отправляем пустой клик, чтобы засчитывался ответ на вопрос
            // важно для обязательных вопросов или для mode=view, где можно только смотреть
            const clicks = clicksRef.current.length
                ? clicksRef.current
                : [
                    {
                        timestamp: Date.now(),
                        downTime: 0,
                        upTime: 0
                    }
                ];
            handleEnd({ clicks });
        }
        else if (e.data === 1 && step === 'start') {
            setStep('playback');
        }
    }, [handleEnd, step]);
    (0, react_2.useEffect)(() => {
        playerRef.current.on('stateChange', onStateChange);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return ((0, jsx_runtime_1.jsxs)(question_1.default, Object.assign({}, rest, { id: id, attachmentRef: attachmentRef, isPressed: isHolding }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: question_video_styles_1.default }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b(), hidden: step === 'start' }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('click-area', { step }), 
                    // eslint-disable-next-line @typescript-eslint/no-misused-promises
                    onClick: onClickStartVideo, onMouseDown: mode === 'view' ? undefined : onMouseDown, onMouseUp: mode === 'view' ? undefined : onMouseUp }, { children: step === 'end' && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('after') }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('after-text') }, { children: after.label || '' })) }))) })) })), mode === 'pointer-hold' && (
            // eslint-disable-next-line react/jsx-fragments
            (0, jsx_runtime_1.jsxs)(react_2.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('bar') }, { children: (0, jsx_runtime_1.jsx)(video_status_bar_1.default, { duration: duration, clicks: clicksRef.current, titleTpl: i18n(['statusBarTitle']), currentTime: currTime }) })), (0, jsx_runtime_1.jsxs)(button_1.default, Object.assign({ mix: b('hold-button'), view: 'normal', disabled: step === 'end', size: 'dependent', onMouseDown: onMouseDown, onMouseUp: onMouseUp, onClick: () => {
                            void onClickStartVideo();
                        } }, { children: [i18n(['holdBtn']), "!!"] }))] }))] })));
}
exports.default = QuestionVideo;
